export enum Journey {
  LOGIN = 'DartyAuthParticularUserLogin_NG',
  RESET_PASSWORD = 'DartyResetPasswordAPI_NG',
}
